import React from 'react';
import ReactDOM from 'react-dom/client';
import LOVALanding from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LOVALanding />
  </React.StrictMode>
);
